import type { PropsWithChildren } from 'react'
import { SignInPage } from '@/pages/sign-in'
import { useAuthStore } from '@/store/auth-store'

interface AuthUserProps extends PropsWithChildren {
  requiredRole?: string
}

export const AuthUser = ({ children, requiredRole }: AuthUserProps) => {
  const auth = useAuthStore()

  const verifySession = () => {
    if (auth.id) {
      if (requiredRole && requiredRole === auth.role) {
        return true
      }
      return true
    }
    return false
  }

  return verifySession() ? children : <SignInPage />
}
